import React, { useRef, useEffect, useState, useMemo } from 'react';
import { useQuery } from 'react-query';
import { Card } from 'react-bootstrap';
import * as moment from 'moment';
import $ from 'jquery';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import SmallBox from '../components/small-box/SmallBox';
import {
    POST_API,
    ACCOUNT_API,
    WEB_ANALYSIS,
    LOG_API,
    LOGIN_HISTORY_API,
    ADVERTISING_ANALYSIS_API,
    // BAOCAO_API,
} from '../utils/apiUrl.js';
import { Get } from '../utils/httpProvider';
// import ListPost from './post/ListPost';
import {
    postStatus,
    reportPost,
    objectStatusPost,
    rangeDate,
    rangeDateReport,
    styleSelectDefault,
    rangeDateDashboardNotHaveDate
} from '../utils/define';
import { getDateTimeISOString, dateTimeToStringRequest } from '../utils/helper';
import { AsyncPaginate } from 'react-select-async-paginate';
import Plotly from 'plotly.js-basic-dist';
import createPlotlyComponent from 'react-plotly.js/factory';
import locale from 'plotly.js-locales/vi';
const Plot = createPlotlyComponent(Plotly);
Plotly.register(locale);
Plotly.setPlotConfig({ locale: 'vi' });

const Dashboard = () => {
    return (
        <div className="container-fluid">
            <div className="row" style={{ marginBottom: '20px' }}>
                <div className="col-lg-4">
                </div>
            </div>
        </div>
    );
};

export default Dashboard;
